import React from 'react'
import useForm from 'react-hook-form'
import { Grid, TextField } from '@material-ui/core'

import ClientContext from 'contexts/ClientContext'
import InputCep from 'components/InputCep'
import { RHFInput } from 'react-hook-form-input'
import schemas from 'views/Clients/schemas/index'

const Address = () => {
  const { data, setFormId, setData, nextStep } = React.useContext(ClientContext)
  const { register, handleSubmit, setValue, errors } = useForm({
    validationSchema: schemas.address,
    defaultValues: { ...data.addressAttributes },
  })
  const formId = 'formStepAddress'

  React.useEffect(() => {
    setFormId(formId)
  }, [setFormId])

  const handleRequestCEP = data => {
    if (!data) {
      return
    }

    setValue('city', data.address.city)
    setValue('state', data.address.state)
    setValue('street', data.address.street)
    setValue('neighborhood', data.address.neighborhood)
  }

  const onSubmit = formData => {
    setData(data => ({ ...data, addressAttributes: { ...formData } }))
    nextStep()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} id={formId}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <RHFInput
            as={
              <InputCep
                label="CEP"
                margin="dense"
                onRequest={handleRequestCEP}
                error={!!errors.postalCode}
                helperText={
                  errors && errors.postalCode && errors.postalCode.message
                }
                fullWidth
              />
            }
            name="postalCode"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Rua"
                margin="dense"
                error={!!errors.street}
                helperText={errors && errors.street && errors.street.message}
                fullWidth
              />
            }
            name="street"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Número"
                margin="dense"
                error={!!errors.number}
                helperText={errors && errors.number && errors.number.message}
                fullWidth
              />
            }
            name="number"
            register={register}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <RHFInput
            as={
              <TextField
                label="Bairro"
                margin="dense"
                error={!!errors.neighborhood}
                helperText={
                  errors && errors.neighborhood && errors.neighborhood.message
                }
                fullWidth
              />
            }
            name="neighborhood"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Cidade"
                margin="dense"
                error={!!errors.city}
                helperText={errors && errors.city && errors.city.message}
                fullWidth
              />
            }
            name="city"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Estado"
                margin="dense"
                error={!!errors.state}
                helperText={errors && errors.state && errors.state.message}
                fullWidth
              />
            }
            name="state"
            register={register}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <RHFInput
            as={
              <TextField
                label="Complemento (opcional)"
                margin="dense"
                error={!!errors.complement}
                helperText={
                  errors && errors.complement && errors.complement.message
                }
                fullWidth
              />
            }
            name="complement"
            register={register}
            setValue={setValue}
          />
        </Grid>
      </Grid>
    </form>
  )
}

export default Address
